import { useEffect } from "react"

function formatPageTitle(title: string) {
  return title === "Projekt" ? title : `${title} · Projekt`
}

export function usePageTitle(title: string | null | undefined) {
  useEffect(() => {
    if (!title) return
    document.title = formatPageTitle(title)
  }, [title])
}
